import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import moment from 'moment'

import { UNIT_TYPES } from 'constants'
import { TITLES } from './constants.jsx'

import styles from './Schedule.scss'


const formatTime = time => moment.utc(time).local().format('LT')

export default class Schedule extends React.Component {
    static propTypes = {
        type: PropTypes.oneOf(Object.values(UNIT_TYPES)).isRequired,
        peripheries: PropTypes.array.isRequired,
        tooltip: PropTypes.bool,
    }
    getSortieSchedule() {
        return (
            <div>
                {this.props.peripheries.map(periphery => (
                    <p className={styles.item} key={`sorties-periphery-${periphery.periphery_id}`}>
                        <span className={styles.periphery}>{periphery.name}{':'}</span>
                        <span>
                            {formatTime(periphery.primetime_start)}
                            {' - '}
                            {formatTime(periphery.primetime_end)}
                        </span>
                    </p>
                ))}
            </div>
        )
    }
    getFortBattleSchedule() {
        return (
            <div>
                {this.props.peripheries.map(periphery => {
                    const tickLastIdx = (periphery.matchmaker_ticks.length - 1)
                    const ticks = periphery.matchmaker_ticks.map((time, idx) => {
                        const isLastTick = (idx === tickLastIdx)
                        const divider = (isLastTick ? '' : ', ')
                        return (
                            <span key={`fort-battle-time-${time}`}>
                                {formatTime(time)}{divider}
                            </span>
                        )
                    })
                    return (
                        <p className={styles.item} key={`fort-battle-periphery-${periphery.periphery_id}`}>
                            <span className={styles.periphery}>
                                {periphery.name}{':'}
                            </span>
                            {ticks}
                        </p>
                    )
                })}
            </div>
        )
    }
    render() {
        let peripheriesSchedule
        if (this.props.type === UNIT_TYPES.SORTIE) {
            peripheriesSchedule = this.getSortieSchedule()
        } else if (this.props.type === UNIT_TYPES.FORT_BATTLE) {
            peripheriesSchedule = this.getFortBattleSchedule()
        }

        const className = classNames(styles.base, {
            [styles.base__tooltip]: this.props.tooltip,
        })

        const titleComponent = (
            <p className={styles.title}>
                {TITLES[this.props.type]}
                {this.props.tooltip ? ':' : ''}
            </p>
        )

        return (
            <div className={className}>
                {titleComponent}
                {peripheriesSchedule}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/BattleWizard/components/Schedule/Schedule.jsx